import { render, staticRenderFns } from "./side-list.vue?vue&type=template&id=da10c47e&scoped=true&"
import script from "./side-list.vue?vue&type=script&lang=js&"
export * from "./side-list.vue?vue&type=script&lang=js&"
import style0 from "./side-list.vue?vue&type=style&index=0&id=da10c47e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da10c47e",
  null
  
)

export default component.exports